<div fxLayout="column" fxLayoutAlign="start stretch">
  <div fxLayout="row" fxLayoutAlign="space-between stretch">
    <h3>{{ label }}</h3>
  </div>
  <div class="d3-chart" #d3Chart></div>
</div>
